module.exports = __webpack_public_path__ + "img/seo_glotto_item06.8d61f75.webp";